import type { InferRpcDefinition } from "@redotech/rpc/definition";
// TODO(tsgo): Remove when microsoft/typescript-go#1034 is fixed (check after tsgo 7.1+)
import { groupA } from "./definition-group-a";
import { groupB } from "./definition-group-b";
import { groupC } from "./definition-group-c";
import { groupD } from "./definition-group-d";
import { groupE } from "./definition-group-e";
import { groupF } from "./definition-group-f";
import { groupG } from "./definition-group-g";
import { groupH } from "./definition-group-h";

export const rpcDefinition = {
  ...groupA,
  ...groupB,
  ...groupC,
  ...groupD,
  ...groupE,
  ...groupF,
  ...groupG,
  ...groupH,
};

export type RedoInventoryRpcDefinition = InferRpcDefinition<
  typeof rpcDefinition
>;
